/* Christina Wishlist - client-side handler v5
   ============================================
   v5 (2026-08-05, BUG-07): JEDNO ZRODLO NAZWY DOSTEPNEJ przycisku.
     Przycisk ma w Liquid statyczny `aria-label` ("Dodaj do listy zyczen"), a
     `aria-label` ma pierwszenstwo nad trescia elementu przy wyliczaniu nazwy
     dostepnej. updateButtonState podmienialo tylko `.cb-wishlist-toggle__label`
     i `aria-pressed`, wiec czytnik ekranu po dodaniu produktu slyszal dalej
     "Dodaj do listy zyczen" przy aria-pressed="true".
     Zmierzone 05.08.2026 na karcie kolekcji (anonim):
       przed klikiem  aria-pressed="false" aria-label="Dodaj do listy zyczen"
       po kliku       aria-pressed="true"  aria-label="Dodaj do listy zyczen"  <-- blad
       po cofnieciu   aria-pressed="false" aria-label="Dodaj do listy zyczen"
     Od v5 nazwe dostepna ustawia WYLACZNIE updateButtonState, z tego samego
     lancucha T co widoczna/SR etykieta — nie da sie ich rozjechac.
     Ikona (kontur -> wypelnienie) opiera sie o klase `is-wishlisted` i NIE jest
     tu ruszana; toggle klasy zachowany 1:1.
   v4 (2026-06-19): i18n — labels/toasts localized pl/en/zh-TW via Shopify.locale.
   v3 (2026-05-12): switched endpoint to /apps/christina/wishlist-toggle
   (Cloudflare Worker christina-backend, App Proxy via Christina Custom Backend app).
   Stores {gid, handle} pairs in localStorage for guest mode reconstruction.
   For logged-in: optimistic UI + server sync to customer.metafields.custom.wishlist.
*/
(function() {
  'use strict';

  var WISHLIST_KEY = 'christina_wishlist_local_v2';
  var WISHLIST_KEY_LEGACY = 'christina_wishlist_local';
  var TOGGLE_SELECTOR = '[data-cb-wishlist-toggle]';
  var ENDPOINT = '/apps/christina/wishlist-toggle';

  /* ---------- i18n ---------- */
  var STRINGS = {
    'pl': {
      add: 'Dodaj do listy życzeń',
      remove: 'Usuń z listy życzeń',
      added: '💝 Dodano do listy życzeń',
      removed: 'Usunięto z listy życzeń',
      savedLocal: '💝 Zapisano lokalnie',
      removedShort: 'Usunięto',
      loginToSave: '💝 Zaloguj się, aby zachować listę'
    },
    'en': {
      add: 'Add to wishlist',
      remove: 'Remove from wishlist',
      added: '💝 Added to wishlist',
      removed: 'Removed from wishlist',
      savedLocal: '💝 Saved locally',
      removedShort: 'Removed',
      loginToSave: '💝 Sign in to save your wishlist'
    },
    'zh-TW': {
      add: '加入願望清單',
      remove: '從願望清單移除',
      added: '💝 已加入願望清單',
      removed: '已從願望清單移除',
      savedLocal: '💝 已儲存於本機',
      removedShort: '已移除',
      loginToSave: '💝 登入即可保存願望清單'
    }
  };
  function locale() {
    var l = (window.Shopify && window.Shopify.locale) || document.documentElement.getAttribute('lang') || 'pl';
    if (STRINGS[l]) return l;
    if (l.indexOf('zh') === 0) return 'zh-TW';
    if (l.indexOf('en') === 0) return 'en';
    return 'pl';
  }
  var T = STRINGS[locale()] || STRINGS['pl'];

  /* ---------- localStorage helpers ---------- */
  function readLocal() {
    try {
      var raw = localStorage.getItem(WISHLIST_KEY);
      if (raw) return JSON.parse(raw);
      /* Legacy migration: array of GIDs → array of {gid, handle:null} */
      var legacy = localStorage.getItem(WISHLIST_KEY_LEGACY);
      if (legacy) {
        var items = JSON.parse(legacy);
        return items.map(function(g){ return typeof g === 'string' ? { gid: g, handle: null } : g; });
      }
      return [];
    } catch (e) { return []; }
  }

  function writeLocal(items) {
    try {
      localStorage.setItem(WISHLIST_KEY, JSON.stringify(items));
      /* keep legacy as plain GID array for backward compat */
      localStorage.setItem(WISHLIST_KEY_LEGACY, JSON.stringify(items.map(function(i){ return i.gid; })));
      window.dispatchEvent(new CustomEvent('christina:wishlist:changed', { detail: { items: items } }));
    } catch (e) {}
  }

  function findIndex(items, gid) {
    for (var i = 0; i < items.length; i++) if (items[i].gid === gid) return i;
    return -1;
  }

  /* ---------- UI update ----------
     v5: stan wizualny (klasa), stan ARIA (aria-pressed), nazwa dostepna
     (aria-label) i tekst etykiety wychodza z JEDNEGO wyliczenia i sa zapisywane
     w jednym przebiegu. Nie rozdzielac tych czterech linii — rozjazd miedzy
     aria-pressed a aria-label byl dokladnie trescia BUG-07. */
  function updateButtonState(btn, isWishlisted) {
    var tekst = isWishlisted ? T.remove : T.add;

    if (isWishlisted) btn.classList.add('is-wishlisted');
    else btn.classList.remove('is-wishlisted');

    btn.setAttribute('aria-pressed', isWishlisted ? 'true' : 'false');
    btn.setAttribute('aria-label', tekst);

    var label = btn.querySelector('.cb-wishlist-toggle__label');
    if (label) label.textContent = tekst;
  }

  /* ---------- toast ---------- */
  function showToast(message, type) {
    var existing = document.querySelector('.cb-wishlist-toast');
    if (existing) existing.remove();

    var toast = document.createElement('div');
    toast.className = 'cb-wishlist-toast cb-wishlist-toast--' + (type || 'info');
    toast.setAttribute('role', 'status');
    toast.textContent = message;
    document.body.appendChild(toast);

    requestAnimationFrame(function() { toast.classList.add('is-visible'); });
    setTimeout(function() {
      toast.classList.remove('is-visible');
      setTimeout(function() { toast.remove(); }, 300);
    }, 2800);
  }

  /* ---------- Server sync (logged-in only) ---------- */
  function syncToServer(productGid, action) {
    if (!window.__customer_logged_in) return Promise.resolve({ ok: false, fallback: true });
    return fetch(ENDPOINT, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      body: JSON.stringify({ product_gid: productGid, action: action })
    })
    .then(function(r) {
      if (!r.ok) return { ok: false, fallback: true };
      return r.json().then(function(data) { return { ok: true, data: data }; });
    })
    .catch(function() { return { ok: false, fallback: true }; });
  }

  /* ---------- Toggle handler ---------- */
  function handleToggle(e) {
    var btn = e.currentTarget;
    var gid = btn.dataset.productGid;
    var handle = btn.dataset.productHandle || null;
    var loggedIn = btn.dataset.customerLoggedIn === 'true';
    var isWishlisted = btn.classList.contains('is-wishlisted');
    var action = isWishlisted ? 'remove' : 'add';

    updateButtonState(btn, !isWishlisted);
    btn.disabled = true;

    /* Update localStorage always (used as guest store + offline backup) */
    var items = readLocal();
    var idx = findIndex(items, gid);
    if (action === 'add' && idx === -1) items.push({ gid: gid, handle: handle });
    if (action === 'remove' && idx !== -1) items.splice(idx, 1);
    writeLocal(items);

    if (loggedIn) {
      window.__customer_logged_in = true;
      syncToServer(gid, action).then(function(result) {
        btn.disabled = false;
        if (result.ok) {
          showToast(action === 'add' ? T.added : T.removed, 'success');
        } else {
          showToast(action === 'add' ? T.savedLocal : T.removedShort, 'info');
        }
      });
    } else {
      btn.disabled = false;
      if (action === 'add') showToast(T.loginToSave, 'info');
      else showToast(T.removed, 'info');
    }
  }

  /* ---------- Hydrate buttons from localStorage ---------- */
  function hydrateFromLocal() {
    var items = readLocal();
    if (!items.length) return;
    var gids = items.map(function(i){ return i.gid; });
    document.querySelectorAll(TOGGLE_SELECTOR).forEach(function(btn) {
      var gid = btn.dataset.productGid;
      if (gids.indexOf(gid) !== -1) updateButtonState(btn, true);
    });
  }

  /* ---------- Bind ---------- */
  function bindToggles() {
    document.querySelectorAll(TOGGLE_SELECTOR).forEach(function(btn) {
      if (btn.dataset.cbWishlistBound) return;
      btn.dataset.cbWishlistBound = '1';
      btn.addEventListener('click', handleToggle);
    });
  }

  function init() {
    bindToggles();
    hydrateFromLocal();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  /* T-MOD6 (2026-10-31): laczenie mutacji (karty dochodzace partiami po filtrach), zamiast pelnego bindToggles na kazda zmiane DOM. */
  var bindT = null;
  var observer = new MutationObserver(function() {
    if (bindT) return;
    bindT = setTimeout(function() { bindT = null; bindToggles(); }, 120);
  });
  observer.observe(document.body, { childList: true, subtree: true });

  window.ChristinaWishlist = {
    readLocal: readLocal,
    writeLocal: writeLocal,
    syncToServer: syncToServer
  };
})();
